import React, { Component, Fragment } from 'react'

import Template from './TemplateLandingPage'
import TwoCols from '../../../blocks/LandingPageBlocks/TwoCols'
import WhyUse from '../../../blocks/LandingPageBlocks/WhyUse'
import CardsEstrategias from '../../../blocks/CardsEstrategias/CardsEstrategias'
import NewMenu from '../../../blocks/Menu/NewMenu'
import CenteredTitleSection from '../../../blocks/LandingPageBlocks/CenteredTitleSection'
import Hero from '../../../blocks/LandingPageBlocks/Hero'

export default class CommercialApllicationv2 extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Fragment>
                <NewMenu
                    pixelsToShowMenuWhite={50}
                    mutableMenu
                />
                <Template >
                    <Hero app title={<Fragment><strong>Aplicativo comercial</strong> para indústrias, distribuidoras e representantes</Fragment>} description='Supere metas, organize pedidos, libere tempopara vender mais e conquiste novos mercados.' />
                    <WhyUse title={<Fragment>Por que usar um aplicativo na sua área comercial?</Fragment>} image='man-taking-notes'>
                        <h3>Aplicativo comercial ou força de vendas são nomes comuns para automação de força de vendas (AFV). Na prática, é um aplicativo que tem recursos para aumentar a produtividade do representante na rua e também a organização comercial das indústrias e distribuidoras que recebem os pedidos.</h3>
                        <h3>Com o aplicativo comercial Mercos, o representante possui um catálogo digital, pode enviar os pedidos padronizados, mesmo sem internet, e pode acompanhar seus resultados. Já as empresas, podem acompanhar as atividades dos seus representantes, emitir relatórios e controlar o estoque dos produtos com poucos cliques.</h3>
                    </WhyUse>
                    <CenteredTitleSection title={<Fragment>O aplicativo comercial Mercos ajuda a potencializar e gerenciar suas vendas</Fragment>} />
                    <TwoCols sectionName="mobilidade" />
                    <TwoCols sectionName="entradaPedidos" reverse />
                    <TwoCols sectionName="semErros" />
                    <TwoCols sectionName="imagemProfissional" reverse />
                    <TwoCols sectionName="potencialize" />
                    <TwoCols sectionName="receba24h" />
                </Template>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/CommercialApplicationv2.jsx